import {
  AddPatientInsuranceActionTypes,
  ADD_PATIENT_INSURANCE_FAIL,
  ADD_PATIENT_INSURANCE_LOADING,
  ADD_PATIENT_INSURANCE_SUCCESS,
  AddPatientInsuranceState,
  ADD_PATIENT_INSURANCE_API_MSG,
  ADD_PATIENT_INSURANCE_API_RES,
} from "./ActionTypes";
import { AddPatientInsuranceRes } from "./Model";

const initialStateEditPosts: AddPatientInsuranceState = {
  loading: false,
  addPatientInsuranceRes: {} as AddPatientInsuranceRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const addPatientInsuranceReducer = (
  state = initialStateEditPosts,
  action: AddPatientInsuranceActionTypes
): AddPatientInsuranceState => {
  switch (action.type) {
    case ADD_PATIENT_INSURANCE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case ADD_PATIENT_INSURANCE_SUCCESS:
      return {
        ...state,
        addPatientInsuranceRes: action.payload,
        successMsg: action.successMsg,
      };
    case ADD_PATIENT_INSURANCE_FAIL:
      return {
        ...state,
        addPatientInsuranceRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_PATIENT_INSURANCE_API_MSG:
      return {
        ...state,
        addPatientInsuranceRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_PATIENT_INSURANCE_API_RES:
      return {
        ...state,
        addPatientInsuranceRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
